import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import whiteLogo from '../assets/logomusiblanco.svg';
import logoCFN from '../assets/CFN-xs.png'
import navElementIcon from '../assets/Vector.svg'
import { AppBar, Box, Fade, Modal, TextField, Typography, styled, Toolbar, Grid } from '@mui/material';
import VerifiedIcon from '@mui/icons-material/Verified';
import DeleteIcon from '@mui/icons-material/Delete';
import { setCompletedPurchase, setErrorEncrypt, setResetData } from '../redux/reducer/stepReducer/stepReducer';
import { cancelPurchase, createErrorEmail } from '../redux/reducer/stepReducer/thunks';
import Spinner from '../components/Spinner';
import ButtonDrawer from '../components/ButtonDrawer';
import { CODEMP_CREDITO_ARGENTINO, CODEMP_MUSIMUNDO } from '../utilities';


const customStyles = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '287px',
    bgcolor: '#ECE6F0',
    borderRadius: '20px',
    p: '16px',
    display: "flex",
    alignItems: "center",
    flexDirection: 'column',
    justifyContent: "center"

};

const StyledToolbar = styled(Toolbar)({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "baseline"
});


const ConfirmationView = (props) => {
    const { codpmpol, altCodpmpol, codpme, firstStep, intpol, iiipol, paramsMus } = useSelector((state) => state.firstStep);
    const { companias, codemp } = useSelector(state => state.adminReducer.login);
    const [openModal, setOpenModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [purchaseIsCanceled, setPurchaseIsCanceled] = useState(false);
    const [openModalWithCancelation, setOpenModalWithCancelation] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleCancelation = () => {
        setOpenModal(false);
        setOpenModalWithCancelation(true);
    };

    const handleReject = async () => {
        setIsLoading(true);
        await dispatch(setResetData());
        await dispatch(cancelPurchase(altCodpmpol));
        setIsLoading(false);
        setPurchaseIsCanceled(true);
    };

    const onRepent = () => {
        if (codpme === 'P') {
            setOpenModal(true);
        } else {
            setOpenModalWithCancelation(true);
        };
    };

    const handleConfirmation = async () => {
        localStorage.removeItem("firstStep");
        localStorage.removeItem("titularData");
        localStorage.removeItem("homeData");
        localStorage.removeItem("payMethod");
        localStorage.removeItem("plan");
        localStorage.removeItem("productType");
        localStorage.removeItem("insured");
        if (firstStep.codsec == '12') {
            localStorage.removeItem("typeBeneficiary");
            localStorage.removeItem("beneficiaryData");
            localStorage.removeItem("completedCheck");
            localStorage.removeItem("expanded");
            localStorage.removeItem("checkedItems");
        }
        await dispatch(setResetData());
        navigate('/')
    };

    const handleBackToFirstViewport = async () => {
        localStorage.removeItem("firstStep");
        localStorage.removeItem("titularData");
        localStorage.removeItem("homeData");
        localStorage.removeItem("payMethod");
        localStorage.removeItem("plan");
        localStorage.removeItem("insured");
        localStorage.removeItem("productType");
        if (firstStep.codsec == '12') {
            localStorage.removeItem("typeBeneficiary");
            localStorage.removeItem("completedCheck");
            localStorage.removeItem("expanded");
            localStorage.removeItem("beneficiaryData");
            localStorage.removeItem("checkedItems");
        }
        await dispatch(setResetData());
        setOpenModalWithCancelation(false);
        navigate('/')
    };

    useEffect(() => {
        if (!codpmpol) {
            const firstStep = JSON.parse(localStorage.getItem('firstStep'));
            const titularData = JSON.parse(localStorage.getItem('titularData'));
            let message = `Error Recid | Confirmacion | Intencion: ${firstStep.nro} | DNI TITULAR: ${titularData.dni} | NOMBRE TITULAR: ${titularData.name + ' ' + titularData.lastname}`
            dispatch(createErrorEmail(message));
            dispatch(setErrorEncrypt(true))
            navigate('/error');
        }
        else dispatch(setCompletedPurchase(true));

        return (() => {
            localStorage.removeItem("firstStep");
            localStorage.removeItem("titularData");
            localStorage.removeItem("homeData");
            localStorage.removeItem("payMethod");
            localStorage.removeItem("plan");
            localStorage.removeItem("insured");
            localStorage.removeItem("productType");
            localStorage.removeItem('dataNotebook');
            if (firstStep.codsec == '12') {
                localStorage.removeItem("typeBeneficiary");
                localStorage.removeItem("completedCheck");
                localStorage.removeItem("expanded");
                localStorage.removeItem("beneficiaryData");
                localStorage.removeItem("checkedItems");
            }
        })
    }, []);


    return (
        <div className='confircont' >
            {
                isLoading ?
                    <Spinner />
                    :
                    // <Container style={{ display: 'flex', justifyContent: 'center' }}>
                    //     <div className='ConfirmationView'>
                    //         <div className='NavConfirmation'>
                    //             <div className='navArrowBack' style={{ padding: '12px' }}></div >
                    //             <div style={{ padding: '12px' }}><img style={{ width: 100, marginTop: 12, marginLeft: 50 }} src={whiteLogo} alt="musimundologoblanco" /></div>
                    //             <div style={{ padding: '12px' }}><ButtonDrawer codpmpol={altCodpmpol} /></div>
                    //             {/* <img style={{ width: '100%', marginBottom: '12px' }} src={navElementIcon} alt="navicon" /> */}
                    //         </div >
                    //         <div className='confirmelements'>
                    //             {
                    //                 // codpmeAllowed.includes(codpme) ?
                    //                 <>
                    //                     <div style={{ marginBottom: 30, marginTop: 45 }}>
                    //                         <svg xmlns="http://www.w3.org/2000/svg"
                    //                             width="100"
                    //                             height="100"
                    //                             fill="#01FFA3"
                    //                             class="bi bi-check-circle-fill"
                    //                             viewBox="0 0 16 16">
                    //                             <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16
                    //                     0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477
                    //                     9.417 5.384 7.323a.75.75 0 0 0-1.06 
                    //                     1.06L6.97 11.03a.75.75 0 0 0 
                    //                     1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                    //                         </svg>

                    //                     </div>
                    //                     <div className='Confirmtitle'>
                    //                         <h3>¡Listo!</h3>
                    //                         <h3>Ya tenés tu seguro</h3>
                    //                         <h3>{firstStep.title} | {'Plan'} {firstStep.plapro} | {firstStep.plan}</h3>
                    //                         <h5>N° Venta: {iiipol}</h5>
                    //                     </div>
                    //                     <div style={{ color: '#ffffff', marginBottom: 30, marginTop: 30 }}>
                    //                         <p>Dentro de las 48 hs recibirás en tu</p>
                    //                         <p>email la póliza. Mientras tanto podés</p>
                    //                         <p>descargar la constancia de adhesión.</p>
                    //                     </div>
                    //                     <div style={{ marginBottom: '20px' }}>
                    //                         <div style={{ marginBottom: 20, marginTop: 30 }}>
                    //                             <Stack spacing={1} direction="column" marginTop={3}>
                    //                                 <Button style={{ borderRadius: 20, textTransform: 'capitalize' }} size="small" color="button" variant="outlined" >
                    //                                     <a target="_blank" rel="noreferrer" href={`https://www.itdepsis.com.ar/ftp/pm/certificados/Constancia_de_Adhesion_Provisoria-${codemp}${intpol}.pdf`}>
                    //                                         <label style={{ color: "white", cursor: "pointer" }}>Descargar constancia</label>
                    //                                     </a>
                    //                                 </Button>
                    //                                 <Button
                    //                                     style={{ borderRadius: 20, textTransform: 'capitalize' }}
                    //                                     size="small"
                    //                                     color="button"
                    //                                     text='primary'
                    //                                     variant="contained"
                    //                                     onClick={handleConfirmation}>
                    //                                     Listo
                    //                                 </Button>
                    //                             </Stack>

                    //                         </div>
                    //                         <p style={{ marginTop: 15, color: '#ffffff', cursor: 'pointer' }} onClick={onRepent}>Me arrepentí</p>
                    //                     </div>
                    //                 </>
                    //                 // :
                    //                 // <div className='Confirmtitle' style={{
                    //                 //     display: "flex",
                    //                 //     justifyContent: "center",
                    //                 //     alignItems: "center",
                    //                 //     height: "100vh"
                    //                 // }}>
                    //                 //     <h3>¡Lo lamentamos!</h3>
                    //                 //     <h3>La operación fue rechazada por la compañía de seguros</h3>
                    //                 // </div>
                    //             }
                    //         </div>
                    //     </div>
                    //     <Modal
                    //         open={openModal}
                    //         onClose={() => setOpenModal(false)}
                    //         closeAfterTransition
                    //     >
                    //         <Fade in={openModal}>
                    //             <Box sx={customStyles}>
                    //                 <Typography id="transition-modal-title" variant="h6" component="h4" style={{ fontFamily: 'Roboto' }} >
                    //                     <DeleteIcon color='error' />
                    //                     Revocar compra
                    //                 </Typography>
                    //                 {
                    //                     !purchaseIsCanceled ?
                    //                         <>
                    //                             <TextField
                    //                                 sx={{ width: "100%", margin: "10px", marginTop: "15px", fontSize: "15px" }}
                    //                                 id="standard-multiline-static"
                    //                                 multiline
                    //                                 rows={3}
                    //                                 placeholder="¿Te interesa contarnos el motivo?"
                    //                                 variant="filled"
                    //                             />
                    //                             <div className="contenedorBotones"
                    //                                 style={{
                    //                                     spacing: 9,
                    //                                     display: "flex",
                    //                                     flexDirection: "row",
                    //                                     margin: 13,
                    //                                     position: "relative",
                    //                                 }}>
                    //                                 <Button
                    //                                     style={{ borderRadius: 20, textTransform: "capitalize", color: '#000' }}
                    //                                     size="medium"
                    //                                     onClick={() => setOpenModal(false)}
                    //                                 >
                    //                                     <label style={{ color: "black", cursor: "pointer" }}>Cancelar</label>
                    //                                 </Button>
                    //                                 <Button
                    //                                     style={{ borderRadius: 20, textTransform: "capitalize" }}
                    //                                     size="medium"
                    //                                     color="secondary"
                    //                                     variant="contained"
                    //                                     type="submit"
                    //                                     onClick={handleReject}
                    //                                 >
                    //                                     Revocar
                    //                                 </Button>
                    //                             </div>
                    //                         </>
                    //                         :
                    //                         <>
                    //                             <Stack sx={{ justifyContent: 'center', alignItems: 'center', marginLeft: '25px' }}>
                    //                                 <br />
                    //                                 <Typography id="transition-modal-title"
                    //                                     variant="h6"
                    //                                     component="h4"
                    //                                     style={{ fontFamily: 'Roboto', marginTop: '15px', fontSize: '16px' }}>
                    //                                     ¡La compra fue revocada correctamente!
                    //                                 </Typography>
                    //                                 <div className="contenedorBotones"
                    //                                     style={{

                    //                                         spacing: 9,
                    //                                         display: "flex",
                    //                                         flexDirection: "row",
                    //                                         margin: 10,
                    //                                         position: "relative",
                    //                                     }}>
                    //                                     <Button
                    //                                         style={{ borderRadius: 20, textTransform: "capitalize" }}
                    //                                         size="small"
                    //                                         color="secondary"
                    //                                         variant="contained"
                    //                                         type="submit"
                    //                                         onClick={handleBackToFirstViewport}
                    //                                     >
                    //                                         Finalizar
                    //                                     </Button>
                    //                                 </div>
                    //                             </Stack>
                    //                         </>
                    //                 }
                    //             </Box>
                    //         </Fade>
                    //     </Modal>
                    //     <Modal
                    //         open={openModalWithCancelation}
                    //         onClose={handleBackToFirstViewport}
                    //         closeAfterTransition
                    //     >
                    //         <Fade in={openModalWithCancelation}>
                    //             <Box sx={customStyles}>
                    //                 <Stack sx={{ justifyContent: 'center', alignItems: 'center', marginLeft: '25px' }}>
                    //                     <br />
                    //                     <Typography id="transition-modal-title"
                    //                         variant="h6"
                    //                         component="h4"
                    //                         style={{ fontFamily: 'Roboto', marginTop: '20px' }}>
                    //                         Hemos procesado y enviado tu póliza
                    //                     </Typography>
                    //                     <Typography sx={{ fontSize: '14px' }}>
                    //                         Si desea dar la baja de la misma, comuníquese al {companias?.find((e) => e.value === firstStep.codcia)?.tel} - {companias?.find((e) => e.value === firstStep.codcia)?.label}
                    //                     </Typography>
                    //                     <div className="contenedorBotones"
                    //                         style={{

                    //                             spacing: 9,
                    //                             display: "flex",
                    //                             flexDirection: "row",
                    //                             margin: 10,
                    //                             position: "relative",
                    //                         }}>
                    //                         <Button
                    //                             style={{ borderRadius: 20, textTransform: "capitalize" }}
                    //                             size="small"
                    //                             color="secondary"
                    //                             variant="contained"
                    //                             type="submit"
                    //                             onClick={handleBackToFirstViewport}
                    //                         >
                    //                             Entendido
                    //                         </Button>
                    //                     </div>
                    //                 </Stack>
                    //             </Box>
                    //         </Fade>
                    //     </Modal>
                    // </Container >
                    <Grid container display={'flex'} justifyContent={'center'}>
                        <div className='ConfirmationView'>
                            <AppBar position='sticky' sx={{ backgroundColor: 'transparent', boxShadow: 'none' }}>
                                <StyledToolbar>
                                    <Box>
                                        {
                                            CODEMP_CREDITO_ARGENTINO.includes(codemp) ?
                                                <img style={{ width: 100, marginTop: 12, marginLeft: 50 }} src={logoCFN} alt="CFN" />
                                                :
                                                <img style={{ width: '35%', marginTop: 12, marginLeft: '100px' }} src={whiteLogo} alt="MUS" />
                                        }
                                    </Box>
                                    <Box marginRight={'60px'} paddingTop={'25px'}>
                                        <ButtonDrawer codpmpol={paramsMus.nro || altCodpmpol} />
                                    </Box>
                                </StyledToolbar>
                            </AppBar >
                            <div className='confirmelements'>
                                {
                                    <>
                                        <div style={{ marginBottom: 30, marginTop: 45 }}>
                                            <svg xmlns="http://www.w3.org/2000/svg"
                                                width="100"
                                                height="100"
                                                fill="#01FFA3"
                                                class="bi bi-check-circle-fill"
                                                viewBox="0 0 16 16">
                                                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16
                                        0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477
                                        9.417 5.384 7.323a.75.75 0 0 0-1.06 
                                        1.06L6.97 11.03a.75.75 0 0 0 
                                        1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                                            </svg>

                                        </div>
                                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', color: '#ffffff' }} >
                                            <h3>¡Listo!</h3>
                                            <h3>Ya tenés tu seguro</h3>
                                            <Box sx={{ display: "flex", flexDirection: 'row' }}>
                                                <h3>{firstStep.title} | </h3>
                                                <h3 variant='h4'>{firstStep.plapro} | </h3>
                                                <h3 variant='h4'> {firstStep.plan}</h3>
                                            </Box>
                                            <h5>N° Venta: {iiipol}</h5>
                                        </Box>
                                        <div style={{ color: '#ffffff', marginBottom: 30, marginTop: 30 }}>
                                            <p>Dentro de las 48 hs recibirás en tu</p>
                                            <p>email la póliza. Mientras tanto podés</p>
                                            <p>descargar la constancia de adhesión.</p>
                                        </div>
                                        <div style={{ marginBottom: '20px' }}>
                                            <div style={{ marginBottom: 20, marginTop: 30 }}>
                                                <Stack spacing={1} direction="column" marginTop={3}>
                                                    <Button style={{ borderRadius: 20, textTransform: 'capitalize' }} size="small" color="button" variant="outlined" >
                                                        <a target="_blank" rel="noreferrer" href={`https://www.itdepsis.com.ar/ftp/pm/certificados/Constancia_de_Adhesion_Provisoria-${codemp}${intpol}.pdf`}>
                                                            <label style={{ color: "white", cursor: "pointer" }}>Descargar constancia</label>
                                                        </a>
                                                    </Button>
                                                    <Button
                                                        style={{ borderRadius: 20, textTransform: 'capitalize' }}
                                                        size="small"
                                                        color="button"
                                                        text='primary'
                                                        variant="contained"
                                                        onClick={handleConfirmation}>
                                                        Listo
                                                    </Button>
                                                </Stack>

                                            </div>
                                            <p style={{ marginTop: 15, color: '#ffffff', cursor: 'pointer' }} onClick={onRepent}>Me arrepentí</p>
                                        </div>
                                    </>
                                    // :
                                    // <div className='Confirmtitle' style={{
                                    //     display: "flex",
                                    //     justifyContent: "center",
                                    //     alignItems: "center",
                                    //     height: "100vh"
                                    // }}>
                                    //     <h3>¡Lo lamentamos!</h3>
                                    //     <h3>La operación fue rechazada por la compañía de seguros</h3>
                                    // </div>
                                }
                            </div>
                        </div>
                        <Modal
                            open={openModal}
                            onClose={() => setOpenModal(false)}
                            closeAfterTransition
                        >
                            <Fade in={openModal}>
                                <Box sx={customStyles}>
                                    <Typography id="transition-modal-title" variant="h6" component="h4" style={{ fontFamily: 'Roboto' }} >
                                        <DeleteIcon color={CODEMP_MUSIMUNDO.includes(codemp) ? 'error' : 'blue'} />
                                        Revocar compra
                                    </Typography>
                                    {
                                        !purchaseIsCanceled ?
                                            <>
                                                <TextField
                                                    sx={{ width: "100%", margin: "10px", marginTop: "15px", fontSize: "15px" }}
                                                    id="standard-multiline-static"
                                                    multiline
                                                    rows={3}
                                                    placeholder="¿Te interesa contarnos el motivo?"
                                                    variant="filled"
                                                />
                                                <div className="contenedorBotones"
                                                    style={{
                                                        spacing: 9,
                                                        display: "flex",
                                                        flexDirection: "row",
                                                        margin: 13,
                                                        position: "relative",
                                                    }}>
                                                    <Button
                                                        style={{ borderRadius: 20, textTransform: "capitalize", color: '#000' }}
                                                        size="medium"
                                                        onClick={() => setOpenModal(false)}
                                                    >
                                                        <label style={{ color: "black", cursor: "pointer" }}>Cancelar</label>
                                                    </Button>
                                                    <Button
                                                        style={{ borderRadius: 20, textTransform: "capitalize" }}
                                                        size="medium"
                                                        color={CODEMP_MUSIMUNDO.includes(codemp) ? 'secondary' : 'blue'}
                                                        variant="contained"
                                                        type="submit"
                                                        onClick={handleReject}
                                                    >
                                                        Revocar
                                                    </Button>
                                                </div>
                                            </>
                                            :
                                            <>
                                                <Stack sx={{ justifyContent: 'center', alignItems: 'center', marginLeft: '25px' }}>
                                                    <br />
                                                    <Typography id="transition-modal-title"
                                                        variant="h6"
                                                        component="h4"
                                                        style={{ fontFamily: 'Roboto', marginTop: '15px', fontSize: '16px' }}>
                                                        ¡La compra fue revocada correctamente!
                                                    </Typography>
                                                    <div className="contenedorBotones"
                                                        style={{
                                                            spacing: 9,
                                                            display: "flex",
                                                            flexDirection: "row",
                                                            margin: 10,
                                                            position: "relative",
                                                        }}>
                                                        <Button
                                                            style={{ borderRadius: 20, textTransform: "capitalize" }}
                                                            size="small"
                                                            color={CODEMP_MUSIMUNDO.includes(codemp) ? 'secondary' : 'blue'}
                                                            variant="contained"
                                                            type="submit"
                                                            onClick={handleBackToFirstViewport}
                                                        >
                                                            Finalizar
                                                        </Button>
                                                    </div>
                                                </Stack>
                                            </>
                                    }
                                </Box>
                            </Fade>
                        </Modal>
                        <Modal
                            open={openModalWithCancelation}
                            onClose={handleBackToFirstViewport}
                            closeAfterTransition
                        >
                            <Fade in={openModalWithCancelation}>
                                <Box sx={customStyles}>
                                    <Stack sx={{ justifyContent: 'center', alignItems: 'center', marginLeft: '25px' }}>
                                        <br />
                                        <Typography id="transition-modal-title"
                                            variant="h6"
                                            component="h4"
                                            style={{ fontFamily: 'Roboto', marginTop: '20px' }}>
                                            Hemos procesado y enviado tu póliza
                                        </Typography>
                                        <Typography sx={{ fontSize: '14px' }}>
                                            Si desea dar la baja de la misma, comuníquese al {companias?.find((e) => e.value === firstStep.codcia)?.tel} - {companias?.find((e) => e.value === firstStep.codcia)?.label}
                                        </Typography>
                                        <div className="contenedorBotones"
                                            style={{

                                                spacing: 9,
                                                display: "flex",
                                                flexDirection: "row",
                                                margin: 10,
                                                position: "relative",
                                            }}>
                                            <Button
                                                style={{ borderRadius: 20, textTransform: "capitalize" }}
                                                size="small"
                                                color="secondary"
                                                variant="contained"
                                                type="submit"
                                                onClick={handleBackToFirstViewport}
                                            >
                                                Entendido
                                            </Button>
                                        </div>
                                    </Stack>
                                </Box>
                            </Fade>
                        </Modal>
                    </Grid >
            }
        </div>
    )
}

export default ConfirmationView;
